var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelFilterBtnIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 4.2C11.5333 3.93333 11.1333 3.93333 10.8667 4.2L8 7.06667L5.13333 4.2C4.86667 3.93333 4.46667 3.93333 4.2 4.2C3.93333 4.46667 3.93333 4.86667 4.2 5.13333L7.06667 8L4.2 10.8667C3.93333 11.1333 3.93333 11.5333 4.2 11.8C4.33333 11.9333 4.46667 12 4.66667 12C4.86667 12 5 11.9333 5.13333 11.8L8 8.93333L10.8667 11.8C11 11.9333 11.2 12 11.3333 12C11.4667 12 11.6667 11.9333 11.8 11.8C12.0667 11.5333 12.0667 11.1333 11.8 10.8667L8.93333 8L11.8 5.13333C12.0667 4.86667 12.0667 4.46667 11.8 4.2Z",
    fill: "#45455A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelFilterBtnIcon);
export default __webpack_public_path__ + "static/media/del-filter-btn-icon.50a16c6f3f175376b5ae6d57ac60beac.svg";
export { ForwardRef as ReactComponent };